import InfoTip from "./InfoTip";
import { money, signed, pct, dpct, toneOf } from "./metricsMath";

const Th = ({ children, help, left }) => (
  <th className={`${left ? "text-left" : "text-right"} font-medium text-zinc-500 px-2 py-1.5 border-b border-zinc-200 whitespace-nowrap`}>
    <span className="inline-flex items-center gap-1">{children}{help && <InfoTip k={help} side="bottom" />}</span>
  </th>
);

// Detalle mes a mes; en rojo el mes con la razón gastos/entradas más alta.
export default function MonthlyTable({ rows, year }) {
  const peor = rows.reduce((a, r) => (r.ratio != null && (a == null || r.ratio > a.ratio) ? r : a), null);
  return (
    <section className="border border-zinc-200 bg-white rounded-lg p-5 flex flex-col gap-2" data-testid="metrics-table">
      <p className="text-xs text-zinc-500 m-0 leading-relaxed">Se muestran solo los meses con movimientos o saldo en bancos. "Sin registrar" es lo que salió del banco menos los gastos registrados; en rojo, el mes con la razón gastos/entradas más alta.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-xs numeric">
          <thead>
            <tr>
              <Th left>Mes</Th>
              <Th help="inflow">Entró</Th>
              <Th help="outflow">Salió</Th>
              <Th help="net">Neto</Th>
              <Th help="expenses">Gastos</Th>
              <Th help="unregistered">Sin registrar</Th>
              <Th help="ratio">Gastos / entradas</Th>
              <Th help="balance">Saldo al cierre</Th>
              <Th help="growth">Cambio saldo</Th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="px-2 py-6 text-center text-zinc-400 font-body" data-testid="metrics-table-empty">Sin movimientos ni gastos en {year}</td></tr>}
            {rows.map((r) => (
              <tr key={r.month} className="border-b border-zinc-100 last:border-0 hover:bg-zinc-50/60" data-testid={`metrics-row-${r.month}`}>
                <td className="px-2 py-2 text-left font-semibold text-zinc-900 font-body">{r.mes}</td>
                <td className="px-2 py-2 text-right text-[#00873D]">{money(r.entro)}</td>
                <td className="px-2 py-2 text-right text-[#E0000F]">{money(r.salio)}</td>
                <td className={`px-2 py-2 text-right font-semibold ${r.neto >= 0 ? "text-[#00873D]" : "text-[#E0000F]"}`}>{signed(r.neto)}</td>
                <td className="px-2 py-2 text-right">{money(r.gastos)}</td>
                <td className="px-2 py-2 text-right text-zinc-600">{money(Math.max(0, r.sin))}</td>
                <td className={`px-2 py-2 text-right whitespace-nowrap ${r === peor ? "text-[#E0000F] font-semibold" : ""}`} data-testid={`ratio-${r.month}`}>
                  {pct(r.ratio)}
                  <span className="inline-block align-middle w-14 h-1.5 ml-2 bg-zinc-100 rounded-sm overflow-hidden"><i className="block h-full bg-amber-500" style={{ width: `${Math.min(100, (r.ratio || 0) * 100)}%` }} /></span>
                </td>
                <td className="px-2 py-2 text-right text-[#002FA7] font-semibold">{r.saldo == null ? "—" : money(r.saldo)}</td>
                <td className={`px-2 py-2 text-right font-semibold ${toneOf(r.crec)}`} data-testid={`growth-${r.month}`}>{dpct(r.crec)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
